// Formatters. Always render numbers as strings with explicit grouping so SSR/CSR don't diverge.

const MICROS_PER_USD = 100_000_000;

export function microsToUsd(m: number): number { return m / MICROS_PER_USD; }
export function centsToUsd(c: number): number { return c / 100; }

const usdFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
const usdFmt2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function fmtUsd(usd: number): string {
  return usd >= 1000 ? usdFmt.format(usd) : usdFmt2.format(usd);
}

const tokenFmt = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 });
export function fmtTokens(n: number): string {
  if (n < 1000) return n.toString();
  return tokenFmt.format(n);
}

export function fmtPct(p: number): string {
  return `${p.toFixed(1)}%`;
}

export function fmtDate(ms: number): string {
  return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function daysBetween(a: number, b: number): number {
  return Math.max(0, Math.round((b - a) / 86_400_000));
}

export function fmtRelative(ms: number): string {
  const diff = Date.now() - ms;
  const min = 60_000, hr = 3_600_000, day = 86_400_000;
  if (diff < min)   return 'just now';
  if (diff < hr)    return `${Math.floor(diff / min)}m ago`;
  if (diff < day)   return `${Math.floor(diff / hr)}h ago`;
  return `${Math.floor(diff / day)}d ago`;
}
